import { Component, OnInit , Inject, Injectable} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from  '@angular/material/dialog';
@Component({
  selector: 'app-messagedialogue',
  templateUrl: './messagedialogue.component.html',
  styleUrls: ['./messagedialogue.component.css']
})
export class MessagedialogueComponent implements OnInit {

  constructor(private  dialogRef:  MatDialogRef<MessagedialogueComponent>, @Inject(MAT_DIALOG_DATA) public  data:  any) { }

  ngOnInit(): void {
  }
  public  closeMe() {
    this.dialogRef.close();
  }
}
